import { toast, ToastOptions } from "react-toastify";
export const ToastyOrange = (
  content: string,
  options?: ToastOptions | undefined
) => toast.warn(content, options);
